import { render, staticRenderFns } from "./examPage.vue?vue&type=template&id=4d5d98f6&scoped=true"
import script from "./examPage.vue?vue&type=script&lang=js"
export * from "./examPage.vue?vue&type=script&lang=js"
import style0 from "./examPage.vue?vue&type=style&index=0&id=4d5d98f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5d98f6",
  null
  
)

export default component.exports